import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Redirect component for legacy Bulk Create routes.
 * Handles routes: /dashboard/upload and /dashboard/bulk
 * Redirects to Sked Home with postId=new&hrm to open the Create Post modal.
 */
export function BulkUploadRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page with query parameters to open the Create Post modal
    navigate("/dashboard?postId=new&hrm", { replace: true });
  }, [navigate]);

  return null;
}
